import logoMark from '@/assets/logos/logo.png';
import logoHorizontal from '@/assets/logos/logo-horizontal.png';
import { appConfig } from '@/config';
import { cn } from '@/utils/cn';

const sizeClasses = {
  sm: 'h-7',
  md: 'h-9',
  lg: 'h-12',
  xl: 'h-16',
  '2xl': 'h-20',
};

const variantSrc = {
  mark: logoMark,
  horizontal: logoHorizontal,
};

export function BrandLogo({
  className,
  imgClassName,
  variant = 'horizontal',
  size = 'md',
  alt = appConfig.appName,
  style,
  ...props
}) {
  const src = variantSrc[variant] ?? logoHorizontal;

  return (
    <img
      src={src}
      alt={alt}
      style={style}
      className={cn(
        'max-w-full object-contain',
        size ? cn(sizeClasses[size], 'w-auto') : null,
        imgClassName,
        className,
      )}
      {...props}
    />
  );
}
